import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const buildPutObjectKey = ({
  whiteLabelID,
  isLogo,
  isDarkModeLogo,
}: {
  readonly whiteLabelID: string;
  readonly isLogo: boolean;
  readonly isDarkModeLogo?: boolean;
}): string => {
  if (!isLogo) {
    return `${whiteLabelID}-favicon`;
  }
  if (isDarkModeLogo) {
    return `${whiteLabelID}-logo-dark`;
  }
  return `${whiteLabelID}-logo`;
};

export const updateImageAws = (axios: IAxiosInstance) => {
  return async ({
    whiteLabelID,
    contentType,
    usePrimary,
    data,
    putUrl,
    isLogo,
    isDarkModeLogo = false,
  }: ISchema["#/definitions/IUpdateImageAwsArgs"]) => {
    await axios.noRetry.put<ISchema["#/definitions/IUpdateImageAwsResponse"]>(
      putUrl,
      data,
      {
        params: {
          Key: buildPutObjectKey({ whiteLabelID, isLogo, isDarkModeLogo }),
          ContentType: contentType,
          usePrimary,
        },
        headers: {
          "Content-Type": contentType,
        },
        withCredentials: false,
        baseURL: undefined,
      }
    );
  };
};
